export const USER_INFO = {
  languageId: 1,
  name: "English (USA)",
  enabled: true,
  cultureName: "en",
  translatedName: "English (USA)",
};

export const MODULE_BRAND_KEYS = ["generic", "integratec", "memcor", "inge"];

export const UNITS = {
  HOURS: "hours",
  DAYS: "days",
  PERCENTAGE: "%",
  MINUTES: "min",
  FLUX: "LMH",
};

export const CLEANING_TYPES = {
  CIP: "cip",
  CEB: "ceb",
};

export const CHART_LINE_STYLES = {
  CIP: "1px,2px",
  CEB: "dash",
};

export const CHART_LINE_COLORS = {
  TOOL_IDENTIFIED: "black",
  USER_IDENTIFIED: "red",
};
